// crm namespace — Packs (Admin → CRM → Packs, design §E.8, Phase 2).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "enum.packCatalogStatus.active": "Actif",
    "enum.packCatalogStatus.archived": "Archivé",
    "packs.activeClients": "Clients actifs",
    "packs.archive": "Archiver",
    "packs.archiveBody": "Le forfait \"{name}\" ne pourra plus être attribué. Les forfaits déjà attribués ne sont pas modifiés.",
    "packs.archived": "Forfait archivé",
    "packs.archiveTitle": "Archiver ce forfait ?",
    "packs.colActions": "Actions",
    "packs.colActiveClients": "Clients actifs",
    "packs.colName": "Nom",
    "packs.colPrice": "Prix",
    "packs.colSessions": "Séances",
    "packs.create": "+ Créer un forfait",
    "packs.edit": "Modifier",
    "packs.empty": "Aucun forfait pour l'instant",
    "packs.emptyBody": "Créez un forfait de séances pour le vendre en ligne ou l'attribuer hors ligne.",
    "packs.loadFailed": "Impossible de charger les forfaits",
    "packs.showArchived": "Afficher les forfaits archivés",
    "packs.title": "Forfaits",
    "packs.unarchive": "Réactiver",
    "packs.unarchived": "Forfait réactivé",
    "packForm.created": "Forfait créé",
    "packForm.errNameRequired": "Le nom est obligatoire",
    "packForm.errPriceInvalid": "Indiquez un prix valide",
    "packForm.errServiceRequired": "Choisissez un type de séance",
    "packForm.errSessionCountInvalid": "Indiquez un nombre de séances (1 ou plus)",
    "packForm.errValidityInvalid": "Indiquez un nombre de mois valide",
    "packForm.name": "Nom",
    "packForm.namePlaceholder": "Ex. Forfait 10 séances",
    "packForm.perMinuteHint": "Les services facturés à la minute ne peuvent pas être liés à un forfait.",
    "packForm.price": "Prix",
    "packForm.save": "Enregistrer",
    "packForm.service": "Type de séance associé",
    "packForm.servicePlaceholder": "Choisissez un type de séance",
    "packForm.sessionCount": "Nombre de séances",
    "packForm.titleCreate": "Créer un forfait",
    "packForm.titleEdit": "Modifier le forfait",
    "packForm.updated": "Forfait mis à jour",
    "packForm.validity": "Validité (mois, facultatif)",
  },
  en: {
    "enum.packCatalogStatus.active": "Active",
    "enum.packCatalogStatus.archived": "Archived",
    "packs.activeClients": "Active clients",
    "packs.archive": "Archive",
    "packs.archiveBody": "The \"{name}\" pack can no longer be assigned. Packs already assigned are unchanged.",
    "packs.archived": "Pack archived",
    "packs.archiveTitle": "Archive this pack?",
    "packs.colActions": "Actions",
    "packs.colActiveClients": "Active clients",
    "packs.colName": "Name",
    "packs.colPrice": "Price",
    "packs.colSessions": "Sessions",
    "packs.create": "+ Create pack",
    "packs.edit": "Edit",
    "packs.empty": "No packs yet",
    "packs.emptyBody": "Create a session pack to sell it online or assign it offline.",
    "packs.loadFailed": "Packs could not be read",
    "packs.showArchived": "Show archived packs",
    "packs.title": "Packs",
    "packs.unarchive": "Unarchive",
    "packs.unarchived": "Pack reactivated",
    "packForm.created": "Pack created",
    "packForm.errNameRequired": "Name is required",
    "packForm.errPriceInvalid": "Enter a valid price",
    "packForm.errServiceRequired": "Choose a session type",
    "packForm.errSessionCountInvalid": "Enter a session count of 1 or more",
    "packForm.errValidityInvalid": "Enter a valid number of months",
    "packForm.name": "Name",
    "packForm.namePlaceholder": "e.g. 10-session pack",
    "packForm.perMinuteHint": "Per-minute services cannot be linked to a pack.",
    "packForm.price": "Price",
    "packForm.save": "Save",
    "packForm.service": "Linked session type",
    "packForm.servicePlaceholder": "Choose a session type",
    "packForm.sessionCount": "Session count",
    "packForm.titleCreate": "Create pack",
    "packForm.titleEdit": "Edit pack",
    "packForm.updated": "Pack updated",
    "packForm.validity": "Validity (months, optional)",
  },
  es: {
    "enum.packCatalogStatus.active": "Activo",
    "enum.packCatalogStatus.archived": "Archivado",
    "packs.activeClients": "Clientes activos",
    "packs.archive": "Archivar",
    "packs.archiveBody": "El bono \"{name}\" ya no podrá asignarse. Los bonos ya asignados no cambian.",
    "packs.archived": "Bono archivado",
    "packs.archiveTitle": "¿Archivar este bono?",
    "packs.colActions": "Acciones",
    "packs.colActiveClients": "Clientes activos",
    "packs.colName": "Nombre",
    "packs.colPrice": "Precio",
    "packs.colSessions": "Sesiones",
    "packs.create": "+ Crear bono",
    "packs.edit": "Editar",
    "packs.empty": "Aún no hay bonos",
    "packs.emptyBody": "Crea un bono de sesiones para venderlo en línea o asignarlo fuera de línea.",
    "packs.loadFailed": "No se pudieron leer los bonos",
    "packs.showArchived": "Mostrar bonos archivados",
    "packs.title": "Bonos",
    "packs.unarchive": "Reactivar",
    "packs.unarchived": "Bono reactivado",
    "packForm.created": "Bono creado",
    "packForm.errNameRequired": "El nombre es obligatorio",
    "packForm.errPriceInvalid": "Indica un precio válido",
    "packForm.errServiceRequired": "Elige un tipo de sesión",
    "packForm.errSessionCountInvalid": "Indica un número de sesiones de 1 o más",
    "packForm.errValidityInvalid": "Indica un número de meses válido",
    "packForm.name": "Nombre",
    "packForm.namePlaceholder": "P. ej. Bono de 10 sesiones",
    "packForm.perMinuteHint": "Los servicios facturados por minuto no se pueden vincular a un bono.",
    "packForm.price": "Precio",
    "packForm.save": "Guardar",
    "packForm.service": "Tipo de sesión vinculado",
    "packForm.servicePlaceholder": "Elige un tipo de sesión",
    "packForm.sessionCount": "Número de sesiones",
    "packForm.titleCreate": "Crear bono",
    "packForm.titleEdit": "Editar bono",
    "packForm.updated": "Bono actualizado",
    "packForm.validity": "Validez (meses, opcional)",
  },
};
